/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description toExternalListingUrl
 */

export const toExternalListingUrl = (listingId: number) => `/external/r/${listingId}` as const
